export const PAGES = {
  DETAILS: "DETAILS",
  PASSWORD: "PASSWORD",
  ALREADY_REGISTERED: "ALREADY_REGISTERED",
};

export const NEXT_SCREEN = "NEXT_SCREEN";
export const PREVIOUS_SCREEN = "PREVIOUS_SCREEN";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";

export type Actions =
  | {
      type: typeof NEXT_SCREEN | typeof PREVIOUS_SCREEN;
      payload: {
        currentScreen: string;
      };
    }
  | {
      type: typeof SIGN_UP_ERROR;
      payload: {
        currentScreen: string;
        errorMsg: string;
      };
    };
